export enum IntegrationEnums {
    XERO = 'XERO',
}

